<script setup lang="ts">
import { useSelectInitiator } from '../../../model/additional-info/support/info-first-lesson-cancellation/select-initiator.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectInitiator from './info-first-lesson-cancellation/SelectInitiator.vue'

defineOptions({
  name: 'InfoFirstLessonCancellationTutor',
})

const { isRequired } = useSelectInitiator()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Initiator"
      :required="isRequired"
    >
      <SelectInitiator />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
